<template>
  <div class="sms">
    <div v-if="errors.length > 0" class="errors">
      <div v-for="(error, key) in errors" :key="key" class="error">
        {{ error }}
      </div>
    </div>
    <div v-if="alert.length > 0" class="alert alert-success">
      {{ alert }}
    </div>
    <input
      class="code"
      :class="{show: show, danger: validateCode}"
      @input="validateCodeMethod"
      v-model="code"
      type="text"
      v-mask="'####'"
    >
    <button
      v-if="!sent"
      :disabled="!active"
      @click="sendSms"
      class="signSC"
      :class="{disabled: !active}"
      type="button"
    >
      Получить код
    </button>
    <button
      v-if="sent"
      @click="checkSms"
      class="checkSignSC"
      type="button"
    >
      Подписать
    </button>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
// import {url} from "@/profile/main";
// import axios from "axios";

export default {
  name: "SmsComponent",
  props: ["active", "view", "contract_id", "other_params"],
  data: () => {
    return {
      sent: false,
      code: "",
      show: false,
      errors: [],
      alert: "",
      validateCode: false
    };
  },
  methods: {
    validateCodeMethod() {
      if (this.validateCode) {
        this.validateCode = false;
      }
    },
    // send(params) {
    //     return axios
    //         .post(url, {
    //             params: params,
    //         });
    // },
    async sendSms() {
      this.alert = "Введите смс-код, направленный на указанный Вами номер телефона.";
      this.errors = [];

      let params = this.generateParamsSend();
      let api;

      if (this.view === "anketa") {
        api = await this.$api2.get(params);
      } else {
        api = await this.$apipa.get(params);
      }
      if (api.error) {
        this.errors = api.errors;
      }
      if (api.success) {
        this.sent = true;
        this.show = true;
      }
      // console.log(params);
      // this.send(params)
      //     .then(function (response) {
      //         let data = response.data;
      //         // console.log(data);
      //         if (data.state == "ERR") {
      //             $this.errors = [];
      //             if (data.msg_text == 'Токен не указан') {
      //                 $this.errors.push('Сессия истекла, авторизуйтесь пожалйста заново');
      //             } else {
      //                 $this.errors.push(data.msg_text);
      //                 $this.errors.push(data.detailed);
      //             }
      //         }
      //         if (data.state == "OK") {
      //             $this.sent = true;
      //             $this.show = true;
      //             // console.log(data);
      //         }
      //     });
    },
    async checkSms() {
      if (this.code === "") {
        this.errors = [];
        this.errors.push("Необходимо ввести код из смс в поле");
        this.validateCode = true;
        return;
      }
      this.errors = [];
      let params = this.generateParamsCheck(), api;

      if (this.view === "anketa") {
        api = await this.$api2.get(params);
      } else {
        api = await this.$apipa.get(params);
      }
      if (api.error) {
        this.errors = api.errors;
      }
      if (api.success) {
        this.$emit("signed", { result: api.data });
      }

      // this.send(params)
      //     .then(function (response) {
      //         let data = response.data;
      //         // console.log(data);
      //         if (data.state == "ERR") {
      //             $this.errors = [];
      //             $this.errors.push(data.msg_text);
      //             $this.errors.push(data.detailed);
      //         }
      //         if (data.state == "OK") {
      //             $this.$emit('signed', {result: data})
      //             // console.log(data);
      //         }
      //     });
    },
    generateParamsSend() {
      let params;
      if (this.view === "prolongation") {
        params = {
          command: this.view + "_sendSMS",
          contract_id: this.contract_id,
          checkRules: "true",
          checkFields: "true",
          checkCorrect: "true",
          token: this.$myApp.token.get()
        };
      } else if (this.view === "anketa") {
        params = {
          action: "check-anketa-send-sms",
          object: "cpa",
          agreement_id: this.contract_id,
          type: this.other_params.type,
          token: this.$myApp.token.get()
        };
      } else {
        if (this.other_params.type !== undefined) {
          params = {
            command: this.view + "_sendSMS",
            contract_id: this.contract_id,
            type: this.other_params.type,
            token: this.$myApp.token.get()
          };
        } else {
          params = {
            command: this.view + "_sendSMS",
            contract_id: this.contract_id,
            token: this.$myApp.token.get()
          };
        }
      }
      return params;
    },
    generateParamsCheck() {
      let params;
      if (this.view === "prolongation") {
        // console.log(this)
        params = {
          command: this.view + "_checkSMS",
          contract_id: this.contract_id,
          code: this.code,
          bic: this.other_params.bic,
          bank_name: this.other_params.bank_name,
          cor_acc: this.other_params.cor_acc,
          cur_acc: this.other_params.cur_acc,
          phone: this.other_params.phone.includes('(') ? this.other_params.phone.replace(/\D/g, "").substring(1) : this.other_params.phone,
          email: this.other_params.email,
          files: this.other_params.files,
          token: this.$myApp.token.get()
        };
      } else if (this.view === "anketa") {
        params = {
          action: "check-anketa-check-sms",
          object: "cpa",
          agreement_id: this.contract_id,
          type: this.other_params.type,
          sms_code: this.code,
          token: this.$myApp.token.get()
        };
      } else {
        if (this.other_params.type !== undefined) {
          params = {
            command: this.view + "_checkSMS",
            contract_id: this.contract_id,
            code: this.code,
            type: this.other_params.type,
            token: this.$myApp.token.get()
          };
        } else {
          params = {
            command: this.view + "_checkSMS",
            contract_id: this.contract_id,
            code: this.code,
            token: this.$myApp.token.get()
          };
        }
      }
      return params;
    }
  },
  directives: { mask }
};
</script>

<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'],
input[type="number"]:hover,
input[type="number"]:focus {
  appearance: none;
  -moz-appearance: textfield;
}

.sms {
  margin-top: 15px;
}

.code {
  width: 0;
  transition-duration: 1s;
  opacity: 0;
  margin-left: -23px;
  padding: 10px;
  font: 700 20px SourceSansPro, sans-serif;
  line-height: normal;
  border: 2px solid #005cbf;
  outline: #0075D4;
}

.show {
  width: 65px;
  opacity: 1;
  margin-left: 0;
}

.signSC, .checkSignSC {
  padding: 10px;
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  line-height: normal;
  border-radius: .3rem;
}

.checkSignSC {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.disabled {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
  cursor: unset;
}

.error {
  font-weight: 700;
  color: rgb(237, 24, 71);
  font-size: 120%;
}

.danger {
  border: 2px solid red;
}
</style>